import { Kernel } from "../Kernel";
import { MediaLibrary } from "../MediaLibrary";
import { DataProvider } from "../DataStore/DataProvider";

import { IUserInfo } from "./cloud/UserTable";
import { IMedia } from "../../main";

export enum DistanceUnit {
    Meters = "meters",
    Feet = "feet",
}

export enum TemperatureUnit {
    Celsius = "celsius",
    Fahrenheit = "fahrenheit",
}

/**
 * The user table is special in that each user can only have a single record. If it does
 * not exist it will get created
 */
export class UserSettings {
    constructor(
        private readonly _userTable: DataProvider,
        private readonly _mediaLibrary: MediaLibrary
    ) {}

    public async read(userId?: string): Promise<IUserInfo | undefined> {
        if (!userId) {
            userId = Kernel.instance().user?.id;
        }
        return this._userTable.newestOwnedBy(userId as string);
    }

    public async update(userInfo: IUserInfo) {
        return this._userTable.update(userInfo);
    }

    public async getAvatarURL(userInfo: IUserInfo): Promise<string | undefined> {
        return this._getImageURL(userInfo.avatar);
    }

    public async getBannerURL(userInfo: IUserInfo): Promise<string | undefined> {
        return this._getImageURL(userInfo.banner);
    }

    private async _getImageURL(image: IMedia | undefined | null): Promise<string | undefined> {
        if (image) {
            const blob = await this._mediaLibrary.get(image.file.key);
            if (blob) {
                return URL.createObjectURL(blob);
            }
        }
        return undefined;
    }
}
